export const ADD_FILM_REQUEST = "@@adminReducer/ADD_FILM_REQUEST";
export const ADD_FILM_SUCCESS = "@@adminReducer/ADD_FILM_SUCCESS";
export const ADD_FILM_FAIL = "@@adminReducer/ADD_FILM_FAIL";

export const EDIT_FILM = "@@adminReducer/EDIT_FILM";
export const DELETE_FILM = "@@adminReducer/DELETE_FILM";